import { render } from "./add-customer-s.vue?vue&type=template&id=1b3ebe27&scoped=true"
import script from "./add-customer-s.vue?vue&type=script&lang=js"
export * from "./add-customer-s.vue?vue&type=script&lang=js"

import "./add-customer-s.vue?vue&type=style&index=0&id=1b3ebe27&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3ebe27"]])

export default __exports__